import React, { useEffect } from "react";
import Navbar from "../containers/navbar/index";
import Banner from "../containers/banner/index";
import Service from "../containers/service/index";
import Preview from "../containers/preview/index";
import Products from "../containers/products/index";
import Signup from "../containers/signup/index";
import Contact from "../containers/contact/index";
import Footer from "../containers/footer/index";
import CopyRight from "../containers/copyright_text/index";

// Demo (#demo) is the last busline section still to be ported; it slots in
// between Signup and Contact to match the Menu order.
//
// NOTE: CartProvider used to wrap this component directly, but /checkout
// is a sibling route (not nested inside PublicHome), so navigating there
// unmounted the provider along with everything else. CartProvider now
// wraps the whole route tree in App.js instead.
export default function PublicHome() {
  useEffect(() => {
    // React Router doesn't auto-scroll to a URL hash the way a full page
    // load does — this handles landing here from the Menu on another page
    // (e.g. /products) with something like /#service in the URL.
    const hash = window.location.hash;
    if (!hash) return;

    const id = hash.replace('#', '');
    // A short delay lets the sections below actually render first.
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      const header = document.querySelector('.header-sticky');
      const offset = (header ? header.offsetHeight : 90) + 10;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <Banner ChangeClass="demo1" />
      <Service />
      <Preview />
      <Products />
      <Signup />
      <Contact />
      <Footer />
      <CopyRight />
    </>
  );
}
